export class debouncer {

    func = () => { };
    timer = null;
    timeout = 300;
    currentArgs = [];
    bindTo;;

    constructor(func, timeout = 300, bind = undefined) {
        this.func = func;
        this.timeout = timeout;
        this.bindTo = bind || this;
    }

    debounce = (...args) => {
        clearTimeout(this.timer);
        this.currentArgs = args;
        this.timer = setTimeout(() => {
            this.func.apply(this.bindTo, args);
            this.timer = undefined;
        }, this.timeout);
    };

    // Immediately execute the function and clear the timer
    flush = () => {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
            this.func.apply(this.bindTo, this.currentArgs);
        }
    }

    clear = () => {
        clearTimeout(this.timer);
        this.timer = null;
    }
}